import { IMessage } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const setAlerts = createAction('[Alerts] Set alerts', props<{ value: IMessage[] }>());
export const addAlert = createAction('[Alerts] Add alert', props<{ value: IMessage }>());
export const delAlert = createAction('[Alerts] Del alert', props<{ value: string }>());
export const cleanAlerts = createAction('[Alerts] clean alerts');
